/* global hbspt */
export function loadHubspotForm(formId, onFormReady = function() {}, target, hiddenFields = {}) {
    function createForm() {
        if (!(window.hbspt && window.hbspt.forms)) return;

        const options = {
            region: "na1",
            portalId: "25782615",
            formId: formId
        };

        const hasHiddenFields = Object.keys(hiddenFields).length > 0;

        if (typeof onFormReady === 'function' || hasHiddenFields) {
            options.onFormReady = function($form) {
                if (hasHiddenFields) {
                    const formEl = $form[0] ?? $form;
                    Object.entries(hiddenFields).forEach(([name, value]) => {
                        const input = formEl.querySelector(`[name="${name}"]`);
                        if (input) {
                            input.value = value;
                            input.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    });
                }
                if (typeof onFormReady === 'function') onFormReady($form);
            };
        }

        if (target) {
            options.target = target; // CSS selector only, embed v2 ignores DOM elements
        }

        hbspt.forms.create(options);
    }

    function loadHubspotMainScript() {
        const existingScript = document.querySelector('script[src*="js.hsforms.net/forms/embed/v2.js"]');

        if (existingScript) {
            if (window.hbspt && window.hbspt.forms) {
                createForm();
            } else {
                existingScript.addEventListener('load', createForm);
            }
            return;
        }

        // Script neu laden
        const script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/embed/v2.js';
        script.onload = createForm;
        document.head.appendChild(script);
    }

    if (window.hbspt && window.hbspt.forms) {
        createForm();
    } else {
        loadHubspotMainScript();
    }
}

/**
 * Laedt die Formulare aller hubspotForm-Blueprints auf der Seite. Die
 * Formulare sind bewusst nicht an den Cookie-Consent gekoppelt.
 */
export function initHubspotForms(root = document) {
    root.querySelectorAll('section.hubspotForm .hubspotFormContainer[data-form-id]').forEach((container, index) => {
        if (container.dataset.loaded) return;
        container.dataset.loaded = 'true';
        // hbspt.forms.create (embed v2) only accepts a CSS selector as target,
        // a DOM element silently renders nothing.
        if (!container.id) container.id = `hubspotForm-${index}`;
        loadHubspotForm(container.dataset.formId, undefined, `#${container.id}`);
    });
}
